/** "‹ Library". The accessible name repeats the visible label, so voice control can say it. */
export function BackButton({ label, onClick }: { label: string; onClick(): void }) {
  return (
    <button className="quiet back" onClick={onClick} aria-label={`Back to ${label}`}>
      <span aria-hidden>‹ </span>
      {label}
    </button>
  );
}
